import {
  copyToArray2j022khrow2yi as copyToArray,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  parseSnapshotOptions920tt8z7mdfy as parseSnapshotOptions,
  driverSnapshot8nzyivxk5zsq as driverSnapshot,
  driverFind3c0cv7qtsjjqg as driverFind,
  driverFindClickable2yf0q7fq9llcj as driverFindClickable,
} from './DriverSupport.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { driverScreenshotwnxd0hlj28c0 as driverScreenshot } from './DriverScreenshot.js.mjs';
import {
  firstOrNull1982767dljvdy as firstOrNull,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Align_Center_getInstance366ihr7rj12mu as Align_Center_getInstance } from '../models/data.mjs';
import { DriverActionException1ncfunkkb5qm9 as DriverActionException } from './DriverActionException.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Default_getInstance3483fw4bkmewo as Default_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/io/encoding/Base64.mjs';
import {
  encodeToByteArray1onwao0uakjfh as encodeToByteArray,
  decodeToString1x4faah2liw2p as decodeToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { split3d3yeauc4rm2n as split } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  DragData2helsigoeiabk as DragData,
  DragEventn7vmft816tmz as DragEvent,
} from '../models/DragData.mjs';
import { None_instance1vdtnxdfytk8h as None_instance } from '../models/Theme.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function AiDriver$Defaults$defaultDriverActions$slambda($element) {
  return constructCallableReference((args, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = args;
    var tmp$ret$0 = copyToArray(this_0);
    return driverSnapshot($element, parseSnapshotOptions(tmp$ret$0));
  }), 1);
}
function AiDriver$Defaults$defaultDriverActions$slambda_0($element) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return yield* driverScreenshot($element, $completion);
  }), 1);
}
function AiDriver$Defaults$defaultDriverActions$slambda_1($element) {
  return constructCallableReference((args, $completion) => orPromise($completion, function *($completion) {
    var tmp0_elvis_lhs = firstOrNull(args);
    return driverFind($element, tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, args.contains_aljjnj_k$('--hidden'));
  }), 1);
}
function AiDriver$Defaults$defaultDriverActions$slambda_2($element) {
  return constructCallableReference((args, $completion) => orPromise($completion, function *($completion) {
    var tmp0_elvis_lhs = firstOrNull(args);
    return driverFindClickable($element, tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, args.contains_aljjnj_k$('--hidden'));
  }), 1);
}
function AiDriver$Defaults$defaultDriverActions$slambda_3($element) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    $element.scrollIntoView_zcj1gb_k$(Align_Center_getInstance(), Align_Center_getInstance(), false);
    return 'OK';
  }), 1);
}
function AiDriver$Defaults$defaultDriverActions$slambda_4($element) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    var tmp0_elvis_lhs = $element.get_dragData_pas5on_k$();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw DriverActionException().new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$('no dragData on this view');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var data = tmp;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
    this_0.append_22ad7x_k$(data.label_1);
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = data.typeToData_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.next_20eer_k$();
      // Inline function 'kotlin.collections.component1' call
      var mime = _destruct__k2r9zo.get_key_18j28a_k$();
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.get_value_j01efc_k$();
      this_0.append_58al37_k$(_Char___init__impl__6a9atx(0));
      this_0.append_22ad7x_k$(mime);
      this_0.append_58al37_k$(_Char___init__impl__6a9atx(0));
      this_0.append_22ad7x_k$(value);
    }
    var serialized = this_0.toString();
    return Default_getInstance().encode$default_h4nonq_k$(encodeToByteArray(serialized));
  }), 1);
}
function AiDriver$Defaults$defaultDriverActions$slambda_5($element) {
  return constructCallableReference((args, $completion) => orPromise($completion, function *($completion) {
    var tmp0_elvis_lhs = firstOrNull(args);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw DriverActionException().new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$('drop requires base64 drag data argument');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var encoded = tmp;
    var decoded = decodeToString(Default_getInstance().decode$default_mne14l_k$(encoded));
    var parts = split(decoded, charArrayOf([_Char___init__impl__6a9atx(0)]));
    var tmp_0;
    if ((parts.get_size_woubt6_k$() % 2 | 0) === 0) {
      throw DriverActionException().new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$('invalid drag data format: expected label followed by mime/value pairs');
    }
    var label = parts.get_c1px32_k$(0);
    // Inline function 'kotlin.collections.associate' call
    var this_0 = step(until(1, parts.get_size_woubt6_k$()), 2);
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
    var inductionVariable = this_0.first_1;
    var last = this_0.last_1;
    var step_0 = this_0.step_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        var it = element;
        // Inline function 'kotlin.collections.plusAssign' call
        var pair = to(parts.get_c1px32_k$(it), parts.get_c1px32_k$(it + 1 | 0));
        destination.put_4fpzoq_k$(pair.first_1, pair.second_1);
      }
       while (!(element === last));
    var typeToData = destination;
    var dragData = DragData().new_com_lightningkite_kiteui_models_DragData_1zeh93_k$(label, typeToData);
    var tmp1_elvis_lhs = $element.get_dropTargetDelegate_fbdv1u_k$();
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      throw DriverActionException().new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$('no drop target found on this view or ancestors');
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var delegate = tmp_1;
    var event = new (DragEvent())(dragData, 0.0, 0.0);
    delegate.enter_5nrpdt_k$(event);
    var result = delegate.drop_tc4way_k$(event);
    delegate.end_keguu6_k$(event);
    var tmp_2;
    if (result) {
      tmp_2 = 'OK';
    } else {
      throw DriverActionException().new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$('drop was rejected by the target');
    }
    return tmp_2;
  }), 1);
}
var DefaultsClass;
function Defaults() {
  if (DefaultsClass === VOID) {
    class $ {
      defaultDriverActions_pnx2nx_k$(element) {
        // Inline function 'kotlin.collections.buildMap' call
        // Inline function 'kotlin.collections.buildMapInternal' call
        // Inline function 'kotlin.apply' call
        var this_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        this_0.put_4fpzoq_k$('snapshot', AiDriver$Defaults$defaultDriverActions$slambda(element));
        this_0.put_4fpzoq_k$('screenshot', AiDriver$Defaults$defaultDriverActions$slambda_0(element));
        this_0.put_4fpzoq_k$('find', AiDriver$Defaults$defaultDriverActions$slambda_1(element));
        this_0.put_4fpzoq_k$('findClickable', AiDriver$Defaults$defaultDriverActions$slambda_2(element));
        this_0.put_4fpzoq_k$('scrollIntoView', AiDriver$Defaults$defaultDriverActions$slambda_3(element));
        if (!(element.get_dragData_pas5on_k$() == null)) {
          this_0.put_4fpzoq_k$('getDragData', AiDriver$Defaults$defaultDriverActions$slambda_4(element));
        }
        if (!(element.get_dropTargetDelegate_fbdv1u_k$() == null)) {
          this_0.put_4fpzoq_k$('drop', AiDriver$Defaults$defaultDriverActions$slambda_5(element));
        }
        return this_0.build_nmwvly_k$();
      }
      defaultDriverDisplay_vqjzqt_k$(element, options) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        var name = element.get_debugName_58dolx_k$();
        if (!(name == null)) {
          this_0.append_22ad7x_k$(name + ': ');
        } else {
          var tmp0_safe_receiver = element.get_parent_hy4reb_k$();
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_children_4cwbp4_k$();
          var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.indexOf_si1fv9_k$(element);
          var tmp;
          if (tmp2_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.takeIf' call
            var tmp_0;
            if (tmp2_safe_receiver >= 0) {
              tmp_0 = tmp2_safe_receiver;
            } else {
              tmp_0 = null;
            }
            tmp = tmp_0;
          }
          var tmp3_elvis_lhs = tmp;
          var idx = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
          this_0.append_22ad7x_k$('' + idx + ': ');
        }
        if (options.includeThemes_1) {
          // Inline function 'kotlin.takeUnless' call
          var this_1 = element.get_themeChoice_22tyn3_k$();
          var tmp_1;
          if (!equals(this_1, None_instance)) {
            tmp_1 = this_1;
          } else {
            tmp_1 = null;
          }
          var tmp4_safe_receiver = tmp_1;
          if (tmp4_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            this_0.append_t8pm91_k$(tmp4_safe_receiver);
            this_0.append_58al37_k$(_Char___init__impl__6a9atx(32));
          }
        }
        this_0.append_22ad7x_k$(getKClassFromExpression(element).get_simpleName_r6f8py_k$());
        var tmp5_safe_receiver = element.get_driverValue_yh5neo_k$();
        if (tmp5_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          this_0.append_22ad7x_k$(' = "' + tmp5_safe_receiver + '"');
        }
        if (!element.get_shown_iyiju0_k$()) {
          this_0.append_22ad7x_k$(' (hidden)');
        } else if (!element.get_visible_8zfvk9_k$()) {
          this_0.append_22ad7x_k$(' (invisible)');
        }
        if (options.includeActions_1) {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = element.get_driverActions_8jqr2k_k$().get_keys_wop4xp_k$();
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element_0 = _iterator__ex2g4s.next_20eer_k$();
            if (!(element_0 === 'snapshot') && !(element_0 === 'screenshot') && !(element_0 === 'find') && !(element_0 === 'findClickable') && !(element_0 === 'scrollIntoView') && !(element_0 === 'getAlignment')) {
              destination.add_utx5q5_k$(element_0);
            }
          }
          // Inline function 'kotlin.takeUnless' call
          var tmp_2;
          if (!destination.isEmpty_y1axqb_k$()) {
            tmp_2 = destination;
          } else {
            tmp_2 = null;
          }
          var tmp6_safe_receiver = tmp_2;
          if (tmp6_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            this_0.append_22ad7x_k$(' [' + joinToString(tmp6_safe_receiver, ', ') + ']');
          }
        }
        return this_0.toString();
      }
    }
    initMetadataForObject($, 'Defaults');
    DefaultsClass = $;
  }
  return DefaultsClass;
}
var Defaults_instance;
function Defaults_getInstance() {
  return Defaults_instance;
}
//region block: init
Defaults_instance = new (Defaults())();
//endregion
//region block: exports
export {
  Defaults_instance as Defaults_instancekan2vrugibmn,
};
//endregion

//# sourceMappingURL=AiDriver.mjs.map
